var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-all"},[_c('h3',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.message.introduceTitle)}})]),_c('div',{staticClass:"content-data"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.message.introduceContent)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }